// Reguły karty „Zaproś drugiego rodzica” nad kalendarzem.
// Po każdym zamknięciu przerwa się wydłuża (7 dni, 30 dni), po trzecim karta nie wraca.
// Płacąca rodzina, która zamknęła kartę choć raz, świadomie działa bez drugiego rodzica —
// nie wracamy do niej. Zaproszenie zostaje zawsze dostępne w ustawieniach (zakładka „Dostępy”).

export interface InviteCardDismissals {
  count: number
  lastDismissedAt: string | null
}

export interface InviteCardInput {
  isParentA: boolean
  hasSecondParent: boolean
  hasPendingParentInvite: boolean
  isPaying: boolean
  dismissals: InviteCardDismissals
  now: Date
}

const DAY_MS = 24 * 60 * 60 * 1000
// Przerwa po n-tym zamknięciu (indeks = liczba zamknięć); poza tablicą = nie wraca
const GAP_DAYS_AFTER_DISMISSAL = [0, 7, 30]

export function shouldShowInviteCard(i: InviteCardInput): boolean {
  if (!i.isParentA || i.hasSecondParent || i.hasPendingParentInvite) return false

  const { count, lastDismissedAt } = i.dismissals
  if (count === 0) return true
  if (i.isPaying) return false
  if (count >= GAP_DAYS_AFTER_DISMISSAL.length) return false

  const last = lastDismissedAt ? new Date(lastDismissedAt).getTime() : NaN
  // Uszkodzona data nie może wyłączyć karty na zawsze
  if (!Number.isFinite(last)) return true
  return i.now.getTime() - last >= GAP_DAYS_AFTER_DISMISSAL[count] * DAY_MS
}

export function recordDismissal(state: InviteCardDismissals, now: Date): InviteCardDismissals {
  return { count: state.count + 1, lastDismissedAt: now.toISOString() }
}

const EMPTY: InviteCardDismissals = { count: 0, lastDismissedAt: null }
const storageKey = (familyId: string) => `invite-card-dismissals-${familyId}`

export function readDismissals(familyId: string): InviteCardDismissals {
  try {
    const raw = localStorage.getItem(storageKey(familyId))
    if (!raw) return EMPTY
    const parsed = JSON.parse(raw)
    const count = Number.isInteger(parsed?.count) && parsed.count > 0 ? parsed.count : 0
    const lastDismissedAt = typeof parsed?.lastDismissedAt === 'string' ? parsed.lastDismissedAt : null
    return { count, lastDismissedAt }
  } catch {
    return EMPTY
  }
}

export function saveDismissals(familyId: string, state: InviteCardDismissals): void {
  try {
    localStorage.setItem(storageKey(familyId), JSON.stringify(state))
  } catch {
    // tryb prywatny / zablokowany storage — karta wróci wcześniej, nic więcej
  }
}
